module.exports = __webpack_public_path__ + "static/sign-in-135f1abeb3f4185077d225d020624084.png";